<ui-button
  class="primary"
  [type]="type()"
  [disabled]="disabled()"
  [loading]="loading()"
  [buttonStyle]="buttonStyle()"
  (clicked)="primaryClicked.emit()">
  <ng-content></ng-content>
</ui-button>

<ui-button
  class="secondary"
  type="button"
  [disabled]="disabled()"
  [buttonStyle]="buttonStyle()"
  (clicked)="secondaryClicked.emit()">
  <ui-icon
    [faName]="icon()"
    [faStyle]="iconStyle()">
  </ui-icon>
</ui-button>
